

















import Vue from 'vue'
import Component from 'vue-class-component'
import moment from '@/plugins/moment'
import { BackendGame } from '@/models/BackendGame'
import Countdown from '@/components/Countdown.vue'
@Component({
  props: {
    game: {
      type: Object as () => BackendGame,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: true,
    },
  },
  components: { Countdown },
})
export default class GameCard extends Vue {
  moment = moment

  chooseGame() {
    this.$emit('chooseGame', this.$props.game.id)
  }
}
